@if (canRender) {
    <router-outlet></router-outlet>
  }